<template>
	<div class="ambassadors-carousel">
		<div class="carousel-main">
			<swiper
				class="swiper" :options="swiperOptionThumbs" ref="swiperThumbs"
			>
				<swiper-slide v-for="(ambassador, index) in ambassadors" class="ambassadors-carousel__slide element" :class="`slide-${index}`" :key="index">
					<div class="slide-wrapper">
						<div class="image">
							<img loading="lazy" :src="`${ambassador.picture}`" :title="ambassador.title" :alt="ambassador.title">
							<a :href="`/ambassador/${ambassador.slug}`" :title="$__('strings.text.readmore')" class="stretched-link"></a>
						</div>
					</div>
				</swiper-slide>
			</swiper>
		</div>

		<div class="container carousel-bottom">
			<div class="row">
				<div class="col-lg-6 col-md-8 mx-md-auto">
					<swiper
						ref="swiperFull" :options="swiperOptions" class="swiper"
					>
						<swiper-slide v-for="(ambassador, index) in ambassadors" class="ambassadors-carousel__thumb" :class="`slide-${index}`" :key="index">
							<div class="slide-wrapper">
								<div class="content">
									<h3 v-text="ambassador.title"></h3>
									<p v-text="ambassador.lead"></p>
									<a :href="`/ambassador/${ambassador.slug}`" :title="$__('strings.text.readmore')" class="btn btn-lg btn-primary" v-text="$__('strings.text.readmore')"></a>
								</div>
							</div>
						</swiper-slide>

						<div class="swiper-button-prev" slot="button-prev" id="swiper-prev-ambassadors">
							<svg class="ticon ticon-180"><use xlink:href="/images/icons.svg?v1.3#icon-arrow-right"></use></svg>
						</div>
						<div class="swiper-button-next" slot="button-next" id="swiper-next-ambassadors">
							<svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-arrow-right"></use></svg>
						</div>
					</swiper>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
	name: 'AmbassadorsCarousel',
	components: {
		Swiper,
		SwiperSlide
	},
	props: {
		ambassadors: Array
	},
	data() {
		return {
			swiperOptionThumbs: {
				loop: true,
				loopedSlides: 5, // looped slides should be the same
				slidesPerView: 'auto',
				spaceBetween: 0,
				centeredSlides: true,
				slideToClickedSlide: true,
				touchRatio: 0.5,
				autoHeight: true

			},
			swiperOptions: {
				loop: true,
				autoHeight: true,
				loopedSlides: 5, // looped slides should be the same
				centeredSlides: true,
				slidesPerView: 1,
				navigation: {
					nextEl: '#swiper-next-ambassadors',
					prevEl: '#swiper-prev-ambassadors'
				}
			}
		}
	},
	mounted() {
		this.$nextTick(() => {
			const swiperFull = this.$refs.swiperFull.$swiper;
			const swiperThumbs = this.$refs.swiperThumbs.$swiper;
			swiperFull.controller.control = swiperThumbs;
			swiperThumbs.controller.control = swiperFull;
		})
	}
}

</script>
